import numeral from "numeral";

const numFormat = (val, format = "0,0") => numeral(val).format(format);
const numFormatSpace = (val, format = "0,0") =>
  numFormat(val, format).replace(",", " ");
const numDifference = (first, second) => numeral(first).difference(second);
const numToPercent = (val, format = "0%") =>
  numeral((val > 1 && val / 100) || val).format(format);

export { numFormat, numFormatSpace, numDifference, numToPercent };

export default numeral;
